
import {Component, Vue, Watch} from "vue-property-decorator";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import BorcluForm from "@/components/forms/BorcluForm.vue";
import FormWrapper from "@/components/FormWrapper.vue";
import AlacakList from "@/components/lists/AlacakList.vue";
import TakipAlacakliPicker from "@/components/pickers/TakipAlacakliPicker.vue";
import DokumanList from "@/components/lists/DokumanList.vue";
import {TakipEntity} from "@/entity/TakipEntity";
import {StatusCodeHelper} from "@/helpers/StatusCodeHelper";
import {ProgramPaths} from "@/enum/ProgramPaths";
import Dates from "@/components/inputs/Dates.vue";
import LisansSuresiOverlay from "@/components/LisansSuresiOverlay.vue";

@Component({
  components: {LisansSuresiOverlay, Dates, DokumanList, TakipAlacakliPicker, AlacakList, FormWrapper, BorcluForm, FormDialog, ProgramPaths}
})
export default class TopluTakipTarihi extends Vue {

  bitis: any;
  baslangic: any;
  takip: TakipEntity | null = null;
  araliktakiTakipler = [];
  parser: any;
  xmlDoc: any = [];
  xml = "";
  stepler = [];
  secimler: boolean = false;
  indirmeyeDevamEt: boolean = false;
  takipTarihi = new Date()
  xmlObject = [{
    kart_no: "",
    messages: "",
    status: false,
    color: ""
  }];

  headers = [
    {text: "Kart No", value: "kart_no",align:'start', class: 'my-header-style'},
    {text: "Durum", value: "messages", class: 'my-header-style'},
    {text: "Karta Git", value: "actions",align:'end', class: 'header-actions-style'},
  ];


  icraDairesi: boolean = false;

  secilenler = [];
  e1 = 1;

  basariliMi: boolean[] = []
  indirilecekXmller: any = []
  ready = false;


  hataMesajlari: any = [];
  xmlUyari: boolean = false;
  kontrol: boolean = false;
  eksikVarMi: boolean = false;
  takipNasilAcilacak: string = "online";


  @Watch('secimler')
  stepleriTemizle() {
    this.xmlObject = [];
  }
  onlyAllowNumbers(event:any) {
    if ((event.key < '0' || event.key > '9') && event.key !== 'Backspace' && event.key !== 'Enter') {
      event.preventDefault();
    }
  }
  async belirlenenAraliktakiTakipleriKontrolEt() {
    this.stepleriTemizle();
    this.indirilecekXmller = [];
    this.secilenler = [];
    this.kontrol = true;
    this.indirmeyeDevamEt = false;
    this.baslangic = Number(this.baslangic);
    this.bitis = Number(this.bitis);

    let takipler: any = []
    for (let i = this.baslangic; i <= this.bitis; i++) {
      takipler.push(i)
    }

    let payload: any = {
      takip_ids: takipler,
      takip_tarihi: this.takipTarihi
    }

    try {
      const response: any = await this.$http.post('/api/v1/toplu-takip-tarihi-duzenle/', payload);

      // API yanıtını işle
      if (response.status && response.sonuclar) {
        response.sonuclar.forEach((sonuc: any) => {
          if (sonuc.status) {
            // Başarılı durumlar
            this.xmlObject.push({
              status: true,
              messages: sonuc.message || "Takip tarihi başarıyla güncellendi.",
              kart_no: sonuc.id,
              color: 'rgb(189 255 115)' // Yeşil renk
            });
            this.indirilecekXmller.push(Number(sonuc.id));
          } else {
            // Başarısız durumlar
            this.xmlObject.push({
              status: false,
              messages: sonuc.message || "İşlem başarısız.",
              kart_no: sonuc.id,
              color: 'rgb(255 103 103)' // Kırmızı renk
            });
          }
        });
      }

      this.e1 = 2; // Bir sonraki adıma geç

    } catch (error) {
      console.error('API isteği başarısız:', error);
      // Hata durumunda tüm takipler için hata mesajı göster
      takipler.forEach((takipId: number) => {
        this.xmlObject.push({
          status: false,
          messages: "API isteği başarısız oldu.",
          kart_no: takipId,
          color: 'rgb(255 103 103)'
        });
      });
      this.e1 = 2;
    } finally {
      this.kontrol = false;
      this.ready = true;

      /*// İndirilebilir XML'lerin kontrolü
      if (this.indirilecekXmller.length > 0 && this.indirilecekXmller.length !== this.xmlObject.length) {
        this.indirmeyeDevamEt = true;
      } else if (this.indirilecekXmller.length === this.xmlObject.length && this.indirilecekXmller.length > 0) {
        this.indirmeyeDevamEt = false;
        this.xmlIndir(this.indirilecekXmller);
      } else {
        this.indirmeyeDevamEt = false;
      }*/
    }
  }

  kartaGit(kartNo:any){
    this.$router.push(ProgramPaths.icrapro + "/takip-ekle/" + kartNo);
  }


  async SecilenTakipleriTakipleriKontrolEt() {
    this.stepleriTemizle();
    this.kontrol = true;
    this.basariliMi = [];
    this.baslangic = null;
    this.indirmeyeDevamEt = false;
    this.bitis = null;
    this.indirilecekXmller = [];

    // Seçilen takipleri sayıya çevir
    const takipIds = this.secilenler.map(secilen => Number(secilen));

    const payload = {
      takip_ids: takipIds,
      takip_tarihi: this.takipTarihi
    };

    try {
      StatusCodeHelper.dontShow404Alert = true;
      const response: any = await this.$http.post('/api/v1/toplu-takip-tarihi-duzenle/', payload);

      if (response.status && response.sonuclar) {
        // API yanıtındaki sonuçları işle
        response.sonuclar.forEach((sonuc: any) => {
          if (sonuc.status) {
            // Başarılı durumlar
            this.xmlObject.push({
              status: true,
              messages: sonuc.message || "Takip tarihi başarıyla güncellendi.",
              kart_no: sonuc.id,
              color: 'rgb(189 255 115)' // Yeşil renk
            });
            this.indirilecekXmller.push(Number(sonuc.id));
          } else {
            // Başarısız durumlar
            this.xmlObject.push({
              status: false,
              messages: sonuc.message || "İşlem başarısız.",
              kart_no: sonuc.id,
              color: 'rgb(255 103 103)' // Kırmızı renk
            });
          }
        });
      } else {
        // API yanıtı beklenmeyen formatta ise
        takipIds.forEach(takipId => {
          this.xmlObject.push({
            status: false,
            messages: "Beklenmeyen API yanıtı alındı.",
            kart_no: takipId,
            color: 'rgb(255 103 103)'
          });
        });
      }

    } catch (e) {
      console.error('API isteği başarısız:', e);
      // Hata durumunda seçilen tüm takipler için hata mesajı göster
      takipIds.forEach(takipId => {
        this.xmlObject.push({
          status: false,
          messages: "API isteği başarısız oldu. Lütfen tekrar deneyiniz.",
          kart_no: takipId,
          color: 'rgb(255 103 103)'
        });
      });
    } finally {
      StatusCodeHelper.dontShow404Alert = false;
      this.kontrol = false;
      this.ready = true;

      // İndirilebilir XML'lerin kontrolü
      /*if (!this.eksikVarMi) {
        if (this.indirilecekXmller.length != this.xmlObject.length) {
          this.indirmeyeDevamEt = true;
        } else {
          this.indirmeyeDevamEt = false;
          if (this.indirilecekXmller.length > 0) {
            this.xmlIndir(this.indirilecekXmller);
          }
        }
      }*/

      this.e1 = 2; // Bir sonraki adıma geç
    }
  }


  @Watch('icraDairesi')
  onlineManuelCheck() {
    if (this.icraDairesi) {
      this.takipNasilAcilacak = "manuel";
    } else {
      this.takipNasilAcilacak = "online";
    }
  }

  /*async xmlIndir(degerler: []) {
    console.log("hazır takipleri indir-->", degerler);
    this.xmlUyari = true;
    await this.$http.post('/api/v1/takip/' + this.takipNasilAcilacak + '/toplu-xml-indir', degerler)
        .then((response: any) => {
          var pom = document.createElement('a');
          var data = new Blob([response], {type: 'text/plain'});

          pom.setAttribute('href', window.URL.createObjectURL(data));
          pom.setAttribute('download', 'İcraProTakipXml.xml');
          pom.dataset.downloadurl = ['text/plain', pom.download, pom.href].join(':');

          pom.click();
        })
    this.xmlUyari = false;
  }*/

}
